export const LOCAL_STORAGE_SHOPPING_BASKET_KEY: string = "CP_SHOPPING_BASKET";